import { inject, injectable } from 'inversify'
import { get } from 'lodash-es'
import type { PaginationUrlFilterScalarValueType } from '@/services/tables/types'
import {
  type FilterToFormattedTextConvertable,
  type FormattedTextBadgesValueItem,
  type FormattedTextNode,
  FilterOperationEnum,
} from '@/services/types'
import { SERVICE_TYPES } from '@/core/container/types'
import type ContactService from '@/services/domain/contact/contactService'
import type { ContactSource } from '@/data/models/domain/Contact'
import type TranslateService from '@/services/translateService'

@injectable()
export default class ContactSourceFilterMapper implements FilterToFormattedTextConvertable {
  constructor(
    @inject(SERVICE_TYPES.ContactService) protected readonly contactService: ContactService,
    @inject(SERVICE_TYPES.TranslateService) protected readonly translateService: TranslateService,
  ) {}

  public toFormattedText(filterValue: PaginationUrlFilterScalarValueType): FormattedTextNode[] {
    const sources = get(filterValue, [FilterOperationEnum.in], []) as (ContactSource | 'empty')[]
    const hasEmptySource = sources.includes('empty')

    const result: FormattedTextNode[] = []
    if (hasEmptySource) {
      result.push({
        type: 'italic',
        value: this.translateService.t('myContactsFilters.isEmpty'),
      })
    }
    const badges: FormattedTextBadgesValueItem[] = sources
      .filter((source) => source !== 'empty')
      .map((source) => {
        return {
          name: this.contactService.getSourceText(source),
        }
      })
    if (badges.length > 0) {
      result.push({
        type: 'badges',
        value: badges,
      })
    }
    return result
  }
}
